import { defineComponent as _defineComponent } from 'vue'
import CollateralTransactionExecutor from './CollateralTransactionExecutor.vue';
import { ClientCollateralState, callTriggeredStates } from 'ah-api-gateways';
import { makeFormModel } from 'ah-common-lib/src/form/helpers';
import { radioField } from 'ah-common-lib/src/form/models';
import { formatCurrencyValue } from 'ah-common-lib/src/helpers/currency';
import { FormDefinition } from 'ah-common-lib/src/form/interfaces';
import { computed, reactive, watch } from 'vue';
import { useAhTradesState } from '../..';
import { useOnBehalfOf } from 'ah-common-lib/src/onBehalfOf/useInjectedOBO';

/**
 * Collateral transaction component
 * Displays transaction instructions and the transaction executor component
 *
 * Re-emits all events from CollateralTransactionExecutor
 */


export default /*#__PURE__*/_defineComponent({
  __name: 'CollateralTransaction',
  props: {
    mode: null
  },
  emits: ["action-changed"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'action-changed', value: 'withdraw' | 'post' | 'choose'): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  mode?: 'withdraw' | 'post' | 'choose';
};



const actionTypeFormDef = reactive<FormDefinition>({
  form: makeFormModel({
    name: 'actionTypeForm',
    fieldType: 'form',
    fields: [
      radioField(
        'action',
        '',
        [
          { label: 'Withdraw', value: 'withdraw' },
          { label: 'Post', value: 'post' },
        ],
        {
          defaultValue: 'withdraw',
          inline: true,
        }
      ),
    ],
  }),
  validation: null,
});



const onBehalfOfClient = useOnBehalfOf();

const tradeState = useAhTradesState();

const collaterals = computed(() => {
  const clientId = onBehalfOfClient.value
    ? onBehalfOfClient.value.id
    : tradeState.store.useAuthStore().loggedInIdentity?.client?.id;

  if (clientId) {
    return tradeState.store.useWalletsStore().getCollaterals(clientId);
  }
  return null;
});

const isMarginCallTriggered = computed(
  () => collaterals.value && callTriggeredStates.includes(collaterals.value.state)
);

const isAtZero = computed(() => collaterals.value?.unutilizedCollateral === 0);

const actionType = computed(() => {
  if (props.mode) {
    return props.mode;
  }
  if (collaterals.value) {
    if (!isAtZero.value) {
      if (collaterals.value.effectiveCollateralUtilization === 0) {
        return 'choose';
      }
      if (
        [
          ClientCollateralState.BELOW_RECOMMENDED_RECAP_THRESHOLD,
          ClientCollateralState.ABOVE_RECOMMENDED_RECAP_THRESHOLD,
        ].includes(collaterals.value.state)
      ) {
        return 'withdraw';
      }
    }
  }
  return 'post';
});

const chosenAction = computed(() => {
  if (actionType.value === 'choose') {
    return actionTypeFormDef.form.action ?? 'withdraw';
  }
  return actionType.value;
});

const effectiveCollateralUtilizationAfterUcWithdrawPercentage = computed(() =>
  ((collaterals.value?.effectiveCollateralUtilizationAfterUcWithdraw ?? 0) * 100).toFixed(1)
);

const effectiveCollateralUtilizationAfterRecommendedWithdrawPercentage = computed(() =>
  ((collaterals.value?.effectiveCollateralUtilizationAfterRecommendedWithdraw ?? 0) * 100).toFixed(1)
);

watch(
  actionType,
  () => {
    emit('action-changed', actionType.value);
  },
  { immediate: true }
);

return { __sfc: true,props, actionTypeFormDef, emit, onBehalfOfClient, tradeState, collaterals, isMarginCallTriggered, isAtZero, actionType, chosenAction, effectiveCollateralUtilizationAfterUcWithdrawPercentage, effectiveCollateralUtilizationAfterRecommendedWithdrawPercentage, CollateralTransactionExecutor, ClientCollateralState, formatCurrencyValue }
}

})